import { SnackbarProvider } from 'notistack';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';

import './i18n';

import { UserContext } from './context/userContext';
import useFindUser from './hooks/useFindUser';

import './app.css';
import LoadingContext from './context/loadingContext';

// ----------------------------------------------------------------------

export default function App() {
  const { user, setUser, isLoading } = useFindUser();

  return (
    <SnackbarProvider
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      dense
      autoHideDuration={1000}
      maxSnack={3}
    >
      <LoadingContext>
        <UserContext.Provider value={{ user, setUser, isLoading }}>
          <ThemeProvider>
            <ScrollToTop />
            <BaseOptionChartStyle />
            <Router />
          </ThemeProvider>
        </UserContext.Provider>
      </LoadingContext>
    </SnackbarProvider>
  );
}
